



























































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component

export default class HomePageOne extends Vue {
  @Prop({ type: Boolean, required: false }) isAuthenticated!: boolean
  @Prop({ type: Function, required: false }) setLogInModal!: void
  @Prop({ type: Function, required: false }) makeDeposit!: void
  @Prop({ type: String, required: false }) currencyCode!: string
  @Prop({ type: String, required: false }) fullName!: string
}
